import { useState } from "react";
import { Image as ExpoImage, type ImageProps, type ImageStyle } from "expo-image";
import { ImageSource } from "expo-image/src/Image.types";
import { View, type StyleProp } from "react-native";
import { useUnistyles } from "react-native-unistyles";

interface OptimizedImageProps extends Omit<ImageProps, "style"> {
  source: ImageSource | string;
  style?: StyleProp<ImageStyle>;
  loadingBackgroundColor?: string;
  showLoadingState?: boolean;
}

export function Image({
  source,
  style,
  loadingBackgroundColor,
  showLoadingState = true,
  ...rest
}: OptimizedImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const { theme } = useUnistyles();

  const defaultLoadingColor = loadingBackgroundColor || theme.colors.grey[200];

  return (
    // overflow: hidden on this wrapper (which carries the borderRadius from
    // `style`) clips the child to the rounded rect on all platforms, including
    // expo-image's absolutely-positioned web <img>.
    <View style={[style, { overflow: "hidden", position: "relative" }]}>
      {isLoading && showLoadingState && (
        <View
          style={[
            style,
            {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: defaultLoadingColor,
              zIndex: 1,
            },
          ]}
        />
      )}
      <ExpoImage
        source={source}
        style={style}
        contentFit="cover"
        transition={200}
        onLoadStart={() => showLoadingState && setIsLoading(true)}
        onLoadEnd={() => showLoadingState && setIsLoading(false)}
        {...rest}
      />
    </View>
  );
}
